import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import { containerPresentation, columnPresentation } from '@mts/shared/containerLayout';
import { stylePresentation } from '@mts/shared/blockStyles';
import { useContentEditorContext } from './ContentEditorContext.jsx';

function LayoutNodeView({ node, editor, getPos, selected, kind }) {
  const context = useContentEditorContext();
  const presentation = kind === 'container' ? containerPresentation(node.attrs) : columnPresentation(node.attrs);
  const styles = stylePresentation(node.attrs.styleSettings);
  const sizing = ['fit', 'grow', 'fixed'].includes(node.attrs.layoutSizing) ? node.attrs.layoutSizing : undefined;
  const width = sizing === 'fixed' ? node.attrs.layoutWidth : undefined;
  const empty = !node.textContent && (node.childCount === 0 || (node.childCount === 1 && node.firstChild?.type.name === 'paragraph'));
  const insert = () => {
    const position = getPos();
    if (typeof position !== 'number') return;
    editor.commands.setTextSelection(position + 1);
    context?.openInsertion?.({ parentType: kind, parentPosition: position, position: position + node.nodeSize - 1 });
  };
  return <NodeViewWrapper
    {...presentation.dataAttrs}
    data-content-layout-view={kind}
    data-layout-sizing={sizing}
    data-layout-width={width}
    data-selected={selected ? 'true' : undefined}
    className={`mts-editor-layout ${presentation.className} ${styles.className || ''}`}
    style={{ ...styles.styleObject, ...(kind === 'column' && presentation.attrs.width === 'full' ? { width: '100%', flex: '0 0 100%' } : {}) }}
  >
    <NodeViewContent className="mts-editor-layout-content"/>
    {empty && context && editor.isEditable ? <button type="button" contentEditable={false} aria-label={`Add content to ${kind}`} onMouseDown={(event) => event.preventDefault()} onClick={insert} className="mts-editor-layout-insert">Add content</button> : null}
  </NodeViewWrapper>;
}

export function ContentContainerNodeView(props) { return <LayoutNodeView {...props} kind="container"/>; }
export function ContentColumnNodeView(props) { return <LayoutNodeView {...props} kind="column"/>; }
